module.exports = __webpack_public_path__ + "media/images/icons/link-d2e0195218b4e402ddfbead36f5f2462.svg";